import CreativeGridView from '@/Enums/CampaignManagement/CreativeGridView.enum';
import type { ILineItemCreative, ILineItemForm } from '@/Interfaces/CampaignManagement/LineItem.interface';
import { GridPaginationAndSortFilters } from '@/components/Grid/hooks/useGridApiPaginationAndSort';
import { useAppDispatch } from '@/store/hooks';
import { setFilters } from '@/store/slices/creativeSlice';
import { useCallback, useState } from 'react';
import { useFormContext } from 'react-hook-form';
import CreativesTable from '../Creatives/Table';
import { getColumns } from '../Creatives/Table/columns';
import PixelsModal from '../Creatives/Table/components/PixelsModal';

const CreativeInfo = () => {
  const dispatch = useAppDispatch();

  const { getValues } = useFormContext<ILineItemForm>();

  const associatedCreatives: ILineItemCreative[] = getValues('creatives');

  const [pixelsModalOpen, setPixelsModalOpen] = useState(false);
  const [activeCreativeIndex, setActiveCreativeIndex] = useState<number | null>(null);

  const creativeIds = associatedCreatives.map(creative => creative.id);

  const rows = associatedCreatives.map((creative, index) => ({
    ...creative,
    creativeIndex: index,
  }));

  if (!associatedCreatives.length) {
    return null;
  }

  const handleViewPixels = useCallback((index: number) => {
    setPixelsModalOpen(true);
    setActiveCreativeIndex(index);
  }, []);

  const handlePixelsClose = useCallback(() => {
    setPixelsModalOpen(false);
    setActiveCreativeIndex(null);
  }, []);

  const columns = getColumns({
    handleRelativeWeightChange: () => () => null,
    handleFieldChange: () => () => null,
    creativeIds,
    view: CreativeGridView.LineItemSummary,
    handleViewPixels,
  });

  const setTableFilters = useCallback(
    (filters: GridPaginationAndSortFilters) => dispatch(setFilters(filters)),
    [dispatch],
  );

  return (
    <div>
      {activeCreativeIndex !== null && (
        <PixelsModal
          open={pixelsModalOpen}
          onClose={handlePixelsClose}
          pixels={associatedCreatives[activeCreativeIndex].pixels}
          disabled
        />
      )}
      <p>Associated Creatives</p>
      <div className='my-1'>
        <CreativesTable
          tableData={rows}
          columns={columns}
          checkboxSelection={false}
          rowSelectionModel={[]}
          handleRowSelectionModelChange={() => null}
          withoutPagination
          setTableFilters={setTableFilters}
        />
      </div>
    </div>
  );
};

export default CreativeInfo;
